export const environment = {
    production: true,
    apiUrl: 'https://grjm7q6bnd.us-east-1.awsapprunner.com',
    apiUrlPdf: 'https://staging-billingapi.xenett.com/v1',
  };
  